import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = { class: "tools" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_IconAsButton = _resolveComponent("IconAsButton")
  const _component_AddTracker = _resolveComponent("AddTracker")
  const _component_Column = _resolveComponent("Column")
  const _component_TableScrollable = _resolveComponent("TableScrollable")

  return (_openBlock(), _createElementBlock("section", {
    class: "tracker-widget",
    disabled: typeof $data.saving_idx === 'number'
  }, [
    _createVNode(_component_TableScrollable, {
      ref: "table",
      items: $options.rows,
      "scroll-height": $props.expanded ? '65vh' : '40rem'
    }, {
      "header-left": _withCtx(() => [
        _createElementVNode("h3", null, _toDisplayString($options.title), 1 /* TEXT */)
      ]),
      "header-right": _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_IconAsButton, {
            icon: "copy",
            tooltip: "Copy table",
            size: "1.6rem",
            disabled: !$options.rows.length,
            onClick: _cache[0] || (_cache[0] = $event => (_ctx.$throttle_1000($options.copyText)))
          }, null, 8 /* PROPS */, ["disabled"]),
          _createVNode(_component_IconAsButton, {
            icon: "download",
            tooltip: "Download table",
            size: "1.6rem",
            disabled: !$options.rows.length,
            onClick: _cache[1] || (_cache[1] = $event => (_ctx.$throttle_1000($options.downloadCSV)))
          }, null, 8 /* PROPS */, ["disabled"]),
          _createVNode(_component_IconAsButton, {
            icon: $props.expanded ? 'collapse-06' : 'expand-06',
            tooltip: $props.expanded ? 'Collapse table' : 'Expand table',
            size: "1.6rem",
            onClick: _cache[2] || (_cache[2] = $event => (_ctx.$emit($props.expanded ? 'collapse' : 'expand')))
          }, null, 8 /* PROPS */, ["icon", "tooltip"])
        ])
      ]),
      empty: _withCtx(() => _cache[3] || (_cache[3] = [
        _createTextVNode("No tracker candidates.")
      ])),
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true),
        _createVNode(_component_Column, {
          class: "action",
          style: {"width":"14rem"}
        }, {
          body: _withCtx(({data: {entity, index}}) => [
            _createVNode(_component_AddTracker, {
              tracked: !!entity[$options.user_id_field],
              saving: $data.saving_idx === index,
              onAdd: $event => ($options.addOne(entity, index))
            }, null, 8 /* PROPS */, ["tracked", "saving", "onAdd"])
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 3 /* FORWARDED */
    }, 8 /* PROPS */, ["items", "scroll-height"])
  ], 8 /* PROPS */, _hoisted_1))
}